function isCurrentUserAdmin({ state, output }) {
  let helper = state.get('client.helper.admin.current')
  if (helper) {
    if (helper.isAdmin || helper.isBilles) {
      output.true()
    } else {
      output.false()
    }
  } else {
    output.false()
  }
}

isCurrentUserAdmin.outputs = ['true', 'false']
export default isCurrentUserAdmin



// WEBPACK FOOTER //
// ./src/modules/user/actions/isCurrentUserAdmin.js